import { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import useAuthStore from "../states/zustand/authStore";

const RestrictedRoutes = () => {
    const location = useLocation();

    const { profileData } = useAuthStore();
    return (
        !profileData.isAuth  ? <Outlet  /> : <Navigate to="/" state={{ from: location }} replace />
    );
};

export default RestrictedRoutes;
